import React, {useState, useRef} from 'react';
import {BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import Container from '@mui/material/Container';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import TourList from './components/TourList';
import TourDetail from './components/TourDetail/TourDetail';
import Slide from './components/Header/Slide';
import tours from "./components/data/TourData";

const App = () => {
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [filteredTours, setFilteredTours] = useState([]);
    const [isSearched, setIsSearched] = useState(false);
    const resultsRef = useRef(null);

    const handleLocationChange = (event) => {
        setSelectedLocations(event.target.value);
    };

    const handleSearch = (filteredTours) => {
        setFilteredTours(filteredTours);
        setIsSearched(true);

        if (resultsRef.current) {
            resultsRef.current.scrollIntoView({behavior: 'smooth', block: 'start'});
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
    };

    const location = useLocation();
    const isTourDetailPage = location.pathname.startsWith('/tour/') && !location.pathname.endsWith('/');

    return (
        <div className={'poppins-medium'} style={{display: 'flex', flexDirection: 'column', minHeight: '100vh'}}>
            <Header
                showFixed={true}
                tours={tours}
                selectedLocations={selectedLocations}
                handleLocationChange={handleLocationChange}
                handleSearch={handleSearch}
                resultsRef={resultsRef}
                isTourDetailPage={isTourDetailPage}
            />
            {!isTourDetailPage && <Slide/>}
            <Container style={{flexGrow: 1, marginTop: '20px'}}>
                <Routes>
                    <Route path="/tour/*" element={<TourList filteredTours={filteredTours} isSearched={isSearched}
                                                             resultsRef={resultsRef}/>}/>
                    <Route path="/tour/:id" element={<TourDetail tours={tours}/>}/>
                </Routes>
            </Container>
            <Footer/>
        </div>
    );
};

const AppWrapper = () => (
    <Router>
        <App/>
    </Router>
);

export default AppWrapper;
